import { RootState } from 'store/store';

export const selectDepartmentsData = (state: RootState) => state.departments.departments;
export const selectDepartmentsStatus = (state: RootState) => state.departments.departments;
